(ns io.daskul.webapp.widgets.form.value-with-unit
  "The value-with-unit input (#969): a unit picker inside the number input's
   left section, so the pair reads as one control and still fits a line-item
   cell. The picker owns the glyph — see value-with-unit-logic/unit-props.

   Standalone on purpose: the invoice line editor is hand-written, so a widget
   that existed only as a render-field-widget branch could never be used there."
  (:require
   [uix.core :refer [defui $]]
   [io.daskul.webapp.ui :as ui]
   [io.daskul.webapp.format :as format]
   [io.daskul.webapp.widgets.form.value-with-unit-logic :as logic]))

(defui ^:private chevron []
  ($ :svg {:width 9 :height 6 :viewBox "0 0 10 6" :fill "none"
           :aria-hidden true :style {:opacity 0.55 :flex "none"}}
     ($ :path {:d "M1 1l4 4 4-4" :stroke "currentColor" :strokeWidth 1.5
               :strokeLinecap "round"})))

(defui ^:private unit-picker
  "The unit control, as a menu button rather than a select.

   A Select inside a NumberInput's left section nests an input within an input:
   Mantine styles the inner one to nothing, so the glyph renders as a stray
   character with no hit area and no chevron. A button with a menu is the same
   interaction in markup we control."
  [{:keys [choices selected-value on-change disabled aria-label]}]
  (let [current (or (first (filter #(= selected-value (:value %)) choices))
                    (first choices))]
    ($ ui/menu {:shadow "md" :position "bottom-start" :withinPortal true}
      ($ ui/menu-target
        ($ ui/unstyled-button
          {:type "button"
           :disabled disabled
           :aria-label aria-label
           :style {:display "flex" :alignItems "center" :gap 3
                   :padding "3px 6px" :borderRadius 5
                   :fontSize 14 :fontWeight 600
                   :color "var(--text)"
                   :cursor (if disabled "not-allowed" "pointer")}}
          (:label current)
          ($ chevron)))
      ($ ui/menu-dropdown
        (for [{:keys [value label]} choices]
          ($ ui/menu-item {:key value :onClick #(on-change value)} label))))))

(defui value-with-unit-input
  "Props:
   - value / on-change      - the number and (fn [n])
   - unit / on-unit-change  - the sibling field's value and (fn [s])
   - units                  - the declared unit vector"
  [{:keys [value unit units on-change on-unit-change label description
           required? disabled error aria-label]}]
  (let [selected (logic/selected-unit units unit)]
    ($ ui/number-input
       (merge {:label label
               :description description
               :required required?
               :aria-label aria-label
               :value (if (nil? value) "" value)
               :onChange #(on-change (format/parse-number %))
               :hideControls true
               :disabled disabled
               :error error
               ;; Mantine kills pointer events in a section by default, which
               ;; would render the picker and then ignore every click on it.
               :leftSectionPointerEvents "all"
               :leftSectionWidth 56
               :leftSection
               ($ unit-picker
                  {:choices (logic/unit-choices units)
                   :selected-value (:value selected)
                   :on-change on-unit-change
                   :disabled disabled
                   :aria-label (str (or aria-label label) " unit")})}
              (logic/unit-props selected)))))
